import React, { useContext, useEffect, useState } from 'react';
import { withErrorBoundary, withFeatureGating } from '@nile/components';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
import { cloneDeep } from 'lodash';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import ReportSheet from '@nile/reports/src/modules/reports/components/subpages/ReportSheet';
import { reportObjFormatter } from '@nile/reports/src/modules/reports/helper';
import { GET_REPORT } from '@nile/reports/src/modules/reports/graphql';
import { withRouter } from 'react-router-dom';
import { PDF_REPORT } from '@nile/reports/src/modules/home/constants';

function ReportCascade(props) {
  const {
    data,
    setActiveReport,
    setActiveReportLoading,
    reportType,
    reportId,
    AccountClient,
    setActiveSection,
    isNonAuth = false
  } = props;
  const tabContext = useContext(TabContext);
  const [loading, setLoading] = useState(false);

  const getChartData = (updatedData, chartId) => {
    return updatedData.charts.find((el) => el.chartId === chartId);
  };

  const getReportDetails = async (updatedData) => {
    const updatedNewData = cloneDeep(updatedData);
    const updatedLayout = updatedNewData.layout.layout.map(async (item) => {
      const updatedChart = await getChartData(updatedData, item.chart.chartId);
      return {
        ...item,
        chart: updatedChart
      };
    });
    const latestData = await Promise.all(updatedLayout);
    updatedNewData.layout.layout = latestData;

    setActiveReport(reportObjFormatter(updatedNewData));

    // setActiveSection is for non auth user to show the dashboard name in header and preview chart
    if (setActiveSection && isNonAuth)
      setActiveSection({
        section: reportType,
        data: reportObjFormatter(updatedNewData)
      });
  };

  const getReport = () => {
    AccountClient.query({
      query: GET_REPORT,
      variables: {
        reportId: data.reportId || reportId
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        if (res?.data?.getReport && reportType !== PDF_REPORT) {
          getReportDetails(res.data.getReport);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setActiveReportLoading(false);
      });
  };

  useEffect(() => {
    if (data.reportId || reportId) {
      setLoading(true);
      setActiveReportLoading(true);
    }
  }, [data?.reportId, reportId]);

  useEffect(() => {
    if (data.reportId || reportId) {
      getReport();
    }
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (tabContext?.activeTab?.data?.reportId) {
      getReport();
    }
  }, [tabContext?.activeTab?.data?.reportId]);

  if (loading) {
    return (
      <div className="flex-center full-height">
        <Loading className="w90" />
      </div>
    );
  }

  return <ReportSheet reportType={reportType} />;
}

export const ReportCascadeWithFeatureGating = withFeatureGating(
  withRouter(withErrorBoundary(ReportCascade)),
  {
    mode: 'tease',
    feature: 'ALL_TIME_SHEET'
  }
);

export default withRouter(withErrorBoundary(ReportCascade));
